import { clsx } from 'clsx'
import { Avatar } from './Avatar'

interface StackPerson {
  name: string
  src?: string | null
}

interface AvatarStackProps {
  people: StackPerson[]
  size?: 'sm' | 'md'
  max?: number
  /** Ring colour around each avatar — match the surface behind the stack. */
  ringClassName?: string
  className?: string
}

/**
 * Overlapping cluster of member avatars — used for presence ("5 online") and the
 * founding crew. Reads the community as alive at a glance.
 */
export function AvatarStack({ people, size = 'sm', max = 5, ringClassName = 'ring-white', className }: AvatarStackProps) {
  const shown = people.slice(0, max)
  return (
    <div className={clsx('flex items-center', className)}>
      {shown.map((p, i) => (
        <div
          key={i}
          className={clsx('rounded-full ring-2', ringClassName, i > 0 && '-ml-2.5')}
        >
          <Avatar name={p.name} src={p.src} size={size} />
        </div>
      ))}
    </div>
  )
}
